<template>
  <NodeArticle v-if="node && node.__typename === 'NodeArticle'" v-bind="node" />
  <NodeEvent
    v-else-if="node && node.__typename === 'NodeEvent'"
    v-bind="node"
  />
  <NodePressRelease
    v-else-if="node && node.__typename === 'NodePressRelease'"
    v-bind="node"
  />
  <NodePage v-else-if="node && node.__typename === 'NodePage'" v-bind="node" />
  <div v-else />
</template>

<script lang="ts" setup>
defineOptions({
  name: 'PageNodeCanonical',
})

definePageMeta({
  name: 'node-canonical',
  drupalRoute: true,
})

const { entity: node } = await useDrupalRouteQuery('nodeCanonical')

useRouteCache((c) => c.setCacheable().setMaxAge(600))
await renderPageDependencies()
</script>
